import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=2dc523b8&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=ts"
export * from "./BackToTop.vue?vue&type=script&lang=ts"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=2dc523b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc523b8",
  null
  
)

export default component.exports